module.exports = __webpack_public_path__ + "static/media/hearts.c9f9c38a.svg";